import BaseService from '../BaseService'

export default class LandService extends BaseService {
  constructor() {
    super('public/land')
  }
}
